module.exports = __webpack_public_path__ + "puwenimg4.png?fa4782f9d4f9a7c31d3b3bf6f04e3d3b";